<template>
  <div class="preview-pdf mx-auto mt-5 mb-3">
    <vue-pdf-embed :source="pdfUrl" />
  </div>
</template>
<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';

export default {
  name: 'PdfFilePreview',
  components: {
    VuePdfEmbed,
  },
  props: {
    attachment: {
      type: Object,
      default: () => {},
    },
    pdfUrl: {
      type: String,
      default: '',
    },
    numPages: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss">
  .preview-pdf {
    width: 60%;
  }
  .vue-pdf-embed {
    width: 100%;
  }
  .vue-pdf-embed > div {
    margin-bottom: 8px;
  }

  // RESPONSIVENESS
  @media (max-width: 1024px) {
    .preview-pdf {
      width: calc(100% - 70px);
    }
  }
</style>
